// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

// 用户管理
import User from '@/views/system/User';

import PersonalCenter from '@/views/system/PersonalCenter';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
// 修改密码
import modpass from '@/views/system/modpass';


//诺达印刷订单管理
import WaitCompose from '@/views/orders/WaitCompose';
import WaitDelivery from '@/views/orders/WaitDelivery';
import Deliverid from '@/views/orders/Deliverid';
import Print from '@/views/orders/Print';
import Count from '@/views/orders/Count';
import Buma from '@/views/orders/Buma';
import OrderDetails from '@/views/orders/OrderDetails';
import LabelPrint from '@/views/orders/Label';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
    {
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [
    //   {
    //   path: '/goods/Goods',
    //   name: '商品管理',
    //   component: Goods,
    //   meta: {
    //     requireAuth: true
    //   }
    // },
      // {
    //   path: '/system/user',
    //   name: '用户管理',
    //   component: User,
    //   meta: {
    //     requireAuth: true
    //   }
    // }, {
    //   path: '/system/personalCenter',
    //   name: '个人中心',
    //   component: PersonalCenter,
    //   meta: {
    //     requireAuth: true
    //   }
    // }, {
    //   path: '/system/Module',
    //   name: '菜单管理',
    //   component: Module,
    //   meta: {
    //     requireAuth: true
    //   }
    // },{
    //   path: '/system/Variable',
    //   name: '系统环境变量',
    //   component: Variable,
    //   meta: {
    //     requireAuth: true
    //   }
    // }, {
    //   path: '/system/Permission',
    //   name: '权限管理',
    //   component: Permission,
    //   meta: {
    //     requireAuth: true
    //   }
    // } ,
      {
      path: '/system/modpass',
      name: 'modpass',
      component: modpass,
      meta: {
        requireAuth: true
      }
    },
    //
    //    {
    //   path: '/druid/login',
    //   name: '监控查询',
    //   component: druidLogin,
    //   meta: {
    //     requireAuth: true
    //   }
    // }, {
    //   path: '/charts/statistics',
    //   name: '数据可视化',
    //   component: statistics,
    //   meta: {
    //     requireAuth: true
    //   }
    // },
    //
      {
      path: '/orders/WaitCompose',
      name: '待合成',
      component: WaitCompose,
      meta: {
        requireAuth: true
      }
    }
      , {
        path: '/orders/WaitDelivery',
        name: '待发货',
        component: WaitDelivery,
        meta: {
          requireAuth: true
        }
      }
      , {
        path: '/orders/Deliverid',
        name: '已发货',
        component: Deliverid,
        meta: {
          requireAuth: true
        }
      }
      , {
        path: '/orders/print',
        name: '补码',
        component: Print,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/orders/Count',
        name: '数据面板',
        component: Count,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/orders/Buma',
        name: '补码记录',
        component: Buma,
        meta: {
          requireAuth: true
        }
      }, {
        path: '/orders/OrderDetails',
        name: '物料信息',
        component: OrderDetails,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/orders/LabelPrint',
        name: '标签打印',
        component: LabelPrint,
        meta: {
          requireAuth: true
        }
      }

    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js